<div class="max-w-screen-sm mx-auto p-5 bg-neutral-100">
  @if (entities$ | async; as entities) {
    <div class="grid grid-cols-2 gap-4 flex flex-col">
      @for (entity of entities; track entity) {
        <div>
          @if (entity && entity.name) {
            <app-push-shop-card-atom
              [logoUrl]="apiUrl + entity.type?.thumbnail_url"
              [name]="entity.name"
              [slug]="entity.slug"
            ></app-push-shop-card-atom>
          }
        </div>
      }
    </div>
  }
</div>
